import styled from 'styled-components'
import { animated } from '@react-spring/web'
import { Colors } from 'cio-design-library/design-tokens'

export const Container = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  display: grid;
  place-items: center;
`

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Image = styled.img`
  width: 48px;
  height: 52px;
  align-self: center;
`

export const Text = styled.p``

export const AnimationContainer = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  background-color: ${Colors.Neutral5};
`

export const Wrapper = styled(animated.div)``
